export default __webpack_public_path__ + "static/media/pvn-arte-11.0036f106.webp";